module.exports = __webpack_public_path__ + "img/topup_poin.25bd5a9f.png";